function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import fetchWithNetworkError from '@uppy/utils/lib/fetchWithNetworkError';
var ASSEMBLIES_ENDPOINT = '/assemblies';
export var AssemblyError = /*#__PURE__*/function (_Error) {
  _inherits(AssemblyError, _Error);
  function AssemblyError(message, details, assembly) {
    var _this;
    _classCallCheck(this, AssemblyError);
    _this = _callSuper(this, AssemblyError, [message]);
    _this.details = details;
    _this.assembly = assembly;
    return _this;
  }
  return _createClass(AssemblyError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * A Barebones HTTP API client for Transloadit.
 */
var _headers = /*#__PURE__*/_classPrivateFieldLooseKey("headers");
var _fetchWithNetworkError = /*#__PURE__*/_classPrivateFieldLooseKey("fetchWithNetworkError");
var _fetchJSON = /*#__PURE__*/_classPrivateFieldLooseKey("fetchJSON");
var _reportError = /*#__PURE__*/_classPrivateFieldLooseKey("reportError");
var Client = /*#__PURE__*/function () {
  function Client(_opts) {
    var _this2 = this;
    _classCallCheck(this, Client);
    Object.defineProperty(this, _fetchJSON, {
      value: _fetchJSON2
    });
    Object.defineProperty(this, _headers, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _fetchWithNetworkError, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _reportError, {
      writable: true,
      value: function value(err, params) {
        if (_this2.opts.errorReporting === false) {
          throw err;
        }
        var opts = {
          type: params.type
        };
        if (params.assembly) {
          opts.assembly = params.assembly.assembly_id;
          opts.instance = params.assembly.instance;
        }
        if (params.url) {
          opts.endpoint = params.url;
        }
        _this2.submitError(err, opts).catch(function () {
          // not much we can do then is there
        });
        throw err;
      }
    });
    this.opts = _opts;
    if (this.opts.client != null) {
      _classPrivateFieldLooseBase(this, _headers)[_headers]['Transloadit-Client'] = this.opts.client;
    }
    _classPrivateFieldLooseBase(this, _fetchWithNetworkError)[_fetchWithNetworkError] = this.opts.rateLimitedQueue.wrapPromiseFunction(fetchWithNetworkError);
  }
  _createClass(Client, [{
    key: "createAssembly",
    value: function () {
      var _createAssembly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var _this3 = this;
        var params, fields, signature, expectedFiles, data, url;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _ref.params, fields = _ref.fields, signature = _ref.signature, expectedFiles = _ref.expectedFiles;
              data = new FormData();
              data.append('params', typeof params === 'string' ? params : JSON.stringify(params));
              if (signature) {
                data.append('signature', signature);
              }
              Object.keys(fields).forEach(function (key) {
                data.append(key, String(fields[key]));
              });
              data.append('num_expected_upload_files', String(expectedFiles));
              url = new URL(ASSEMBLIES_ENDPOINT, "".concat(this.opts.service)).href;
              return _context.abrupt("return", _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
                method: 'POST',
                headers: _classPrivateFieldLooseBase(this, _headers)[_headers],
                body: data
              }).catch(function (err) {
                return _classPrivateFieldLooseBase(_this3, _reportError)[_reportError](err, {
                  url: url,
                  type: 'API_ERROR'
                });
              }));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createAssembly(_x) {
        return _createAssembly.apply(this, arguments);
      }
      return createAssembly;
    }()
    /**
     * Reserve resources for a file in an Assembly. Then addFile can be used later.
     */
  }, {
    key: "reserveFile",
    value: (function () {
      var _reserveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(assembly, file) {
        var _this4 = this;
        var size, url;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              size = encodeURIComponent(file.size);
              url = "".concat(assembly.assembly_ssl_url, "/reserve_file?size=").concat(size);
              return _context2.abrupt("return", _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
                method: 'POST',
                headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
              }).catch(function (err) {
                return _classPrivateFieldLooseBase(_this4, _reportError)[_reportError](err, {
                  assembly: assembly,
                  file: file,
                  url: url,
                  type: 'API_ERROR'
                });
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function reserveFile(_x2, _x3) {
        return _reserveFile.apply(this, arguments);
      }
      return reserveFile;
    }()
    /**
     * Import a remote file to an Assembly.
     */
    )
  }, {
    key: "addFile",
    value: (function () {
      var _addFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(assembly, file) {
        var _this5 = this;
        var size, uploadUrl, filename, fieldname, qs, url;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (file.uploadURL) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", Promise.reject(new Error('File does not have an `uploadURL`.')));
            case 2:
              size = encodeURIComponent(file.size);
              uploadUrl = encodeURIComponent(file.uploadURL);
              filename = encodeURIComponent(file.name);
              fieldname = 'file';
              qs = "size=".concat(size, "&filename=").concat(filename, "&fieldname=").concat(fieldname, "&s3Url=").concat(uploadUrl);
              url = "".concat(assembly.assembly_ssl_url, "/add_file?").concat(qs);
              return _context3.abrupt("return", _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
                method: 'POST',
                headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
              }).catch(function (err) {
                return _classPrivateFieldLooseBase(_this5, _reportError)[_reportError](err, {
                  assembly: assembly,
                  file: file,
                  url: url,
                  type: 'API_ERROR'
                });
              }));
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function addFile(_x4, _x5) {
        return _addFile.apply(this, arguments);
      }
      return addFile;
    }()
    /**
     * Cancel a running Assembly.
     */
    )
  }, {
    key: "cancelAssembly",
    value: (function () {
      var _cancelAssembly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(assembly) {
        var _this6 = this;
        var url;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = assembly.assembly_ssl_url;
              return _context4.abrupt("return", _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
                method: 'DELETE',
                headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
              }).catch(function (err) {
                return _classPrivateFieldLooseBase(_this6, _reportError)[_reportError](err, {
                  url: url,
                  type: 'API_ERROR'
                });
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function cancelAssembly(_x6) {
        return _cancelAssembly.apply(this, arguments);
      }
      return cancelAssembly;
    }()
    /**
     * Get the current status for an assembly.
     */
    )
  }, {
    key: "getAssemblyStatus",
    value: (function () {
      var _getAssemblyStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(url) {
        var _this7 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
                headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
              }).catch(function (err) {
                return _classPrivateFieldLooseBase(_this7, _reportError)[_reportError](err, {
                  url: url,
                  type: 'STATUS_ERROR'
                });
              }));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getAssemblyStatus(_x7) {
        return _getAssemblyStatus.apply(this, arguments);
      }
      return getAssemblyStatus;
    }())
  }, {
    key: "submitError",
    value: function () {
      var _submitError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(err, _temp) {
        var _ref2, endpoint, instance, assembly, message;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref2 = _temp === void 0 ? {} : _temp, endpoint = _ref2.endpoint, instance = _ref2.instance, assembly = _ref2.assembly;
              message = err.details ? "".concat(err.message, " (").concat(err.details, ")") : err.message;
              return _context6.abrupt("return", _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON]('https://transloaditstatus.com/client_error', {
                method: 'POST',
                body: JSON.stringify({
                  endpoint: endpoint,
                  instance: instance,
                  assembly_id: assembly,
                  agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
                  client: this.opts.client,
                  error: message
                })
              }));
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function submitError(_x8, _x9) {
        return _submitError.apply(this, arguments);
      }
      return submitError;
    }()
  }]);
  return Client;
}();
export { Client as default };
function _fetchJSON2() {
  return _fetchJSON3.apply(this, arguments);
}
function _fetchJSON3() {
  _fetchJSON3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _classPrivateFieldLoo;
    var response,
      _classPrivateFieldLoo2,
      serverError,
      _args7 = arguments;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _fetchWithNetworkError))[_fetchWithNetworkError].apply(_classPrivateFieldLoo, _args7);
        case 2:
          response = _context7.sent;
          if (!(response.status === 429)) {
            _context7.next = 6;
            break;
          }
          this.opts.rateLimitedQueue.rateLimit(2000);
          return _context7.abrupt("return", (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _fetchJSON))[_fetchJSON].apply(_classPrivateFieldLoo2, _args7));
        case 6:
          if (response.ok) {
            _context7.next = 12;
            break;
          }
          serverError = new Error(response.statusText); // @ts-expect-error statusCode is not a standard property
          serverError.statusCode = response.status;
          if ("".concat(_args7.length <= 0 ? undefined : _args7[0]).endsWith(ASSEMBLIES_ENDPOINT)) {
            _context7.next = 11;
            break;
          }
          return _context7.abrupt("return", Promise.reject(serverError));
        case 11:
          return _context7.abrupt("return", response.json().then(function (assembly) {
            if (!assembly.error) throw serverError;
            var error = new AssemblyError(assembly.error, assembly.message, assembly);
            if (assembly.assembly_id) {
              error.details += " Assembly ID: ".concat(assembly.assembly_id);
            }
            throw error;
          }, function (err) {
            // eslint-disable-next-line no-param-reassign
            err.cause = serverError;
            throw err;
          }));
        case 12:
          return _context7.abrupt("return", response.json());
        case 13:
        case "end":
          return _context7.stop();
      }
    }, _callee7, this);
  }));
  return _fetchJSON3.apply(this, arguments);
}